import { render, staticRenderFns } from "./LevelLeaderBoard.vue?vue&type=template&id=da6ef0f0&scoped=true"
import script from "./LevelLeaderBoard.vue?vue&type=script&lang=js"
export * from "./LevelLeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./LevelLeaderBoard.vue?vue&type=style&index=0&id=da6ef0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6ef0f0",
  null
  
)

export default component.exports